import { createSlice } from "@reduxjs/toolkit";
import { faqTopRatedAwardsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const faqTopRatedAwardsSlice = createSlice({
  name: "faqTopRatedAwards",
  initialState: data,
  reducers: {
    faqTopRatedAwardsSlice(state) {
      state.isLoading = false;
    },
    faqTopRatedAwardsSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    faqTopRatedAwardsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    faqTopRatedAwardsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const faqTopRatedAwardsHandler = () => async (dispatch: any) => {
  try {
    dispatch(faqTopRatedAwardsAction.faqTopRatedAwardsSlice());
    const response: any = await faqTopRatedAwardsAPI();
    dispatch(faqTopRatedAwardsAction.faqTopRatedAwardsSliceSuccess(response));
  } catch (e: any) {
    dispatch(faqTopRatedAwardsAction.faqTopRatedAwardsSliceFailure(e?.response?.data?.message));
    dispatch(faqTopRatedAwardsAction.faqTopRatedAwardsSliceReset());
  }
};
export default faqTopRatedAwardsSlice.reducer;
export const faqTopRatedAwardsAction = faqTopRatedAwardsSlice.actions;
